import React, { useRef, useEffect, useState } from "react";
import Globe from "react-globe.gl";
import "../style/CareerGlobe.css";

const LOCATIONS = [
  { id: "kaohsiung", label: "Kaohsiung, Taiwan", lat: 22.63, lng: 120.30, color: "#f9a8d4", size: 0.6  },
  { id: "ucsc",      label: "UCSC",             lat: 36.97, lng: -122.03, color: "#e8c9a0", size: 0.55 },
  { id: "silicon",   label: "Silicon Valley",   lat: 37.38, lng: -122.08, color: "#d4a574", size: 0.65 },
  { id: "umich",     label: "UMich MADS",       lat: 42.28, lng: -83.74,  color: "#93c5fd", size: 0.65 },
];

const ARCS = [
  // Taiwan → US (immigration)
  { startLat: 22.63, startLng: 120.30, endLat: 36.97, endLng: -122.03,
    color: ["rgba(249,168,212,0.9)", "rgba(232,201,160,0.9)"] },
  // Taiwan → Michigan (grad school)
  { startLat: 22.63, startLng: 120.30, endLat: 42.28, endLng: -83.74,
    color: ["rgba(249,168,212,0.8)", "rgba(99,102,241,0.8)"] },
  // UCSC → Silicon Valley (work)
  { startLat: 36.97, startLng: -122.03, endLat: 37.38, endLng: -122.08,
    color: ["rgba(232,201,160,0.9)", "rgba(212,165,116,0.9)"] },
  // Silicon Valley → Michigan (grad school)
  { startLat: 37.38, startLng: -122.08, endLat: 42.28, endLng: -83.74,
    color: ["rgba(52,211,153,0.9)", "rgba(99,102,241,0.9)"] },
];

const CareerGlobe = () => {
  const globeRef = useRef();
  const containerRef = useRef();
  const [width, setWidth] = useState(680);
  const HEIGHT = 440;

  // Responsive width
  useEffect(() => {
    const update = () => {
      if (containerRef.current) setWidth(containerRef.current.offsetWidth);
    };
    update();
    window.addEventListener("resize", update, { passive: true });
    return () => window.removeEventListener("resize", update);
  }, []);

  // Setup controls after mount
  useEffect(() => {
    if (!globeRef.current) return;
    const timer = setTimeout(() => {
      const ctrl = globeRef.current.controls();
      ctrl.autoRotate = true;
      ctrl.autoRotateSpeed = 0.35;
      ctrl.enableZoom = false;
      ctrl.enablePan = false;
      // Focus on contiguous US
      // Center between Taiwan and US
      globeRef.current.pointOfView({ lat: 35, lng: -170, altitude: 1.8 }, 0);
    }, 200);
    return () => clearTimeout(timer);
  }, [width]);  // re-run when width changes (Globe re-mounts)

  return (
    <div className="career-globe-wrap">
      <div ref={containerRef} className="career-globe-canvas" aria-hidden="true">
        <Globe
          ref={globeRef}
          width={width}
          height={HEIGHT}
          backgroundColor="rgba(0,0,0,0)"
          globeImageUrl="//cdn.jsdelivr.net/npm/three-globe/example/img/earth-night.jpg"
          bumpImageUrl="//cdn.jsdelivr.net/npm/three-globe/example/img/earth-topology.png"
          backgroundImageUrl="//cdn.jsdelivr.net/npm/three-globe/example/img/night-sky.png"
          showAtmosphere={true}
          atmosphereColor="#7dd3fc"
          atmosphereAltitude={0.13}
          // Arc connections
          arcsData={ARCS}
          arcColor="color"
          arcDashLength={0.5}
          arcDashGap={3}
          arcDashAnimateTime={1400}
          arcStroke={0.6}
          arcAltitudeAutoScale={0.4}
          // Location dots
          pointsData={LOCATIONS}
          pointLat="lat"
          pointLng="lng"
          pointAltitude={0.04}
          pointColor="color"
          pointRadius="size"
          pointsMerge={false}
          // Pulse rings
          ringsData={LOCATIONS}
          ringLat="lat"
          ringLng="lng"
          ringColor={() => "rgba(6,182,212,0.5)"}
          ringMaxRadius={2.5}
          ringPropagationSpeed={2.5}
          ringRepeatPeriod={900}
        />
      </div>

      <div className="career-globe-legend">
        {LOCATIONS.map((l) => (
          <div key={l.id} className="globe-legend-item">
            <span className="globe-legend-dot" style={{ background: l.color }} />
            <span className="globe-legend-label">{l.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareerGlobe;
